import {observer} from 'mobx-react';
import {useNavigate} from 'react-router-dom';
import UrlsService from '../../../../common/router/services/urlsService.mdl';
import {useChartsListContext} from '../context/ChartsListContext';
import {Button, ButtonsList} from '@vidazoo/ui-kit';
import {ReactComponent as ChartsIcon} from '../assets/scenarios.svg';
import {ReactComponent as PlusIcon} from '../assets/plus-small.svg';
import theme from '../view/theme.module.scss';
import {ChartBulkAction} from '../model/ChartsListModel.mdl';

export default observer(function ChartsHeader() {
    const navigate = useNavigate();
    const {model, tableRowSelectionHook} = useChartsListContext();
    const {selectedItems, toggleItem, clearSelection} = tableRowSelectionHook;
    const bulk = (action: ChartBulkAction) => model.confirmBulkAction(action, selectedItems,
        completed => {
            clearSelection();
            selectedItems.filter(id => !completed.includes(id)).forEach(id => toggleItem(id));
        });

    return <div className={theme.header}>
        <h1 className={theme.title}><ChartsIcon className={theme.titleIcon} aria-hidden="true" focusable="false"/>Charts</h1>
        <div className={theme.buttons}>
            <Button type="button" blue medium iconName={<PlusIcon className={theme.plusIcon} aria-hidden="true" focusable="false"/>} className={theme.create}
                    onClick={() => navigate(UrlsService.createChart())}>Create Chart</Button>
            <ButtonsList className={theme.bulk} label="Bulk Action" disabled={!selectedItems.length || !!model.pendingIds.length}>
                <Button onClick={() => bulk('delete')}>Delete</Button>
                <Button onClick={() => bulk('activate')}>Activate</Button>
                <Button onClick={() => bulk('deactivate')}>Deactivate</Button>
            </ButtonsList>
        </div>
    </div>;
});
